'use client'

import { useState } from 'react'

import { formatDateOnly } from '@/utils/date'
import { downloadBlob } from '@/utils/misc'
import { withString } from '@/utils/string'
import { trackClickDownloadDataInduk } from '@/utils/tracker/modules/datainduk'
import { TrackerSection, TrackerSubSection } from '@/utils/tracker/shared'
import {
  DataIndukFiltersWithKeywordParams,
  useMutateDownloadDataInduk,
} from '@/apis/useDataInduk'

import { useDownloadSurvey } from '@/components/DownloadSurvey/DownloadSurveyProvider'

import { ButtonDownloadView } from './ButtonDownloadView'

interface ButtonDownloadProps extends DataIndukFiltersWithKeywordParams {
  disabled?: boolean
  lastUpdatedAt: string
}

function generateFileTitle({
  bentuk,
  jalur,
  status,
  jenis,
  keyword,
  kodeKecamatan,
  sortBy = 'bentuk_pendidikan',
  sortDir = 'asc',
  lastUpdatedAt,
}: ButtonDownloadProps) {
  return `Data Induk Satuan Pendidikan ${kodeKecamatan}${withString(bentuk)}${withString(jalur)}${withString(status)}${withString(jenis)}${withString(sortBy)}${withString(sortDir).toUpperCase()}${withString(keyword)} - Per ${formatDateOnly(lastUpdatedAt || new Date())}`
}

export const ButtonDownloadSatpen = ({
  disabled = false,
  bentuk,
  jalur,
  status,
  jenis,
  keyword,
  kodeKecamatan,
  sortBy = 'bentuk_pendidikan',
  sortDir = 'asc',
  lastUpdatedAt,
}: ButtonDownloadProps) => {
  const { showSurvey } = useDownloadSurvey()

  const [isShowErrorDialog, setShowErrorDialog] = useState<boolean>(false)
  const { mutate, isPending } = useMutateDownloadDataInduk()

  const executeMutation = async (
    fileType: 'csv' | 'xlsx' | 'pdf',
    filenameExt: string
  ) => {
    if (!disabled) {
      trackClickDownloadDataInduk({
        bentuk,
        jalur,
        status,
        jenis,
        keyword,
        locationId: kodeKecamatan || '',
        locationLevel: 'Kecamatan',
        format: fileType,
        section: TrackerSection.SATPEN,
        subSection: TrackerSubSection.PAUD_DIKDASMEN,
      })
      mutate(
        {
          bentuk,
          jalur,
          status,
          jenis,
          keyword,
          kodeKecamatan,
          sortBy,
          format: fileType,
        },
        {
          onSuccess(data) {
            downloadBlob(data, filenameExt)

            // Delay 1s before showing survey dialog
            setTimeout(() => {
              showSurvey('DATA_INDUK')
            }, 500)
          },
          onError() {
            setShowErrorDialog(true)
          },
        }
      )
    }
  }

  const handleDownload = async (fileType: 'csv' | 'xlsx' | 'pdf') => {
    const filename = generateFileTitle({
      bentuk,
      jalur,
      status,
      jenis,
      keyword,
      kodeKecamatan,
      sortBy,
      sortDir,
      lastUpdatedAt,
    })

    const fileWithExt = `${filename}.${fileType}`
    executeMutation(fileType, fileWithExt)
  }

  return (
    <>
      <ButtonDownloadView
        disabled={disabled}
        isPending={isPending}
        isShowErrorDialog={isShowErrorDialog}
        onCloseErrorDialog={() => {
          setShowErrorDialog(false)
        }}
        onDownload={handleDownload}
      />
    </>
  )
}
